import axios from "axios";
import { useState } from "react";
import { useEffect } from "react";
import { createContext } from "react";

const ApplicationsContext = createContext();

export const ApplicationProvider = ({ children }) => {
  const [applications, setApplications] = useState([]);
  const [activeApplicationId, setActiveApplicationId] = useState();
  const [applicationsRefreshTime, setApplicationsRefreshTime] = useState(
    new Date()
  );

  const [accountApplications, setAccountApplications] = useState([]);
  const [activeAccountApplicationId, setActiveAccountApplicationId] = useState();
  const [accountApplicationsRefreshTime, setAccountApplicationsRefreshTime] = useState(
    new Date()
  );

  const refreshAccountApplications = () => {
    setAccountApplicationsRefreshTime(new Date());
  };

  useEffect(() => {
    axios.get("/api/account-applications").then(({ data }) => {
      setAccountApplications(data.items);
    });
  }, [accountApplicationsRefreshTime]);

  const getAccountApplication = (accountApplicationId) => {
    return axios.get("/api/account-applications/" + accountApplicationId);
  };
  const getAccountApplicationByShortCode = (shortCode) => {
    return axios.get("/api/account-applications/by-short-code/" + shortCode);
  };

  const refreshApplications = () => {
    setApplicationsRefreshTime(new Date());
  };

  useEffect(() => {
    axios.get("/api/applications").then(({ data }) => {
      setApplications(data.items);
    });
  }, [applicationsRefreshTime]);

  const getApplication = (applicationId) => {
    return axios.get("/api/applications/" + applicationId);
  };
  const getApplicationByShortCode = (shortCode) => {
    return axios.get("/api/applications/by-short-code/" + shortCode);
  };

  return (
    <ApplicationsContext.Provider
      value={{
        applications,
        refreshApplications,
        activeApplicationId,
        setActiveApplicationId,
        getApplication,
        getApplicationByShortCode,

        accountApplications,
        refreshAccountApplications,
        activeAccountApplicationId,
        setActiveAccountApplicationId,
        getAccountApplication,
        getAccountApplicationByShortCode
      }}
    >
      {children}
    </ApplicationsContext.Provider>
  );
};

export default ApplicationsContext;
